module.exports = (__webpack_require__("dll-reference common"))("./components/wx/base/WxComponentBase.js");